import Constant from '@/const';
import axios from 'axios';

const getAllLaboratory = async ({
  halaman = 1,
  itemCount = 10,
  sortBy,
  keyword,
  category = '',
}) => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(
        `/master/laboratory?category=${category}&page=${halaman}&itemCount=${itemCount}&sort=${sortBy}&search=${keyword}`,
      ),
    );
    return response.data;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getAllLaboratory;
